/*
Identifies the user in Segment with the user ID and email address.
*/

import { identify, identifyWithLocalStorageUTM } from "../analytics";
import { devlog } from "../utils";

const UserIdentifyHook = {
  mounted() {
    const userId = this.el.dataset.userId;
    const email = this.el.dataset.email;
    const withLocalStorageUTM = this.el.dataset.withLocalStorageUtm;

    devlog(`userId is ${userId}`);
    devlog(`email is ${email}`);
    devlog(`withLocalStorageUTM is ${withLocalStorageUTM}`);

    if (withLocalStorageUTM) {
      devlog("localStorage UTM identify");
      identifyWithLocalStorageUTM(userId, { email });
    } else {
      devlog("normal identify");
      identify(userId, { email });
    }
  },
};

export default UserIdentifyHook;
